import { create } from "../../../../../common/utils/zustand_state_manager";
import {
  InitializePaginationProperties,
  InitializeSetPaginationProperties,
  PaginationProperties,
  SetPaginationProperties,
} from "../../../../../common/utils/pagination_property";

type State = PaginationProperties;

type Actions = SetPaginationProperties;

export const useProjetoRevisaoResumoPagination = create<State & Actions>((set) => ({
  ...InitializePaginationProperties(),
  ...InitializeSetPaginationProperties(set),
}));
export type ProjetoRevisaoResumoPaginationStore = PaginationProperties & SetPaginationProperties;